import { render, staticRenderFns } from "./truck_type_edit.vue?vue&type=template&id=35b96414&scoped=true&"
import script from "./truck_type_edit.vue?vue&type=script&lang=js&"
export * from "./truck_type_edit.vue?vue&type=script&lang=js&"
import style0 from "./truck_type_edit.vue?vue&type=style&index=0&id=35b96414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b96414",
  null
  
)

export default component.exports